import SlideOutButton from "../common/SlideOutButton";
import useDevUnlockStagedOrder from "./useDevUnlockStagedOrder";

interface UnlockStagedOrderButtonProps {
  stagedOrderId: string;
}

const UnlockStagedOrderButton = ({ stagedOrderId }: UnlockStagedOrderButtonProps) => {
  const unlockRequest = useDevUnlockStagedOrder(stagedOrderId);

  return <SlideOutButton text="Unlock Staged Order" onClick={() => unlockRequest.request()} />;
}

export default UnlockStagedOrderButton;
